import React from 'react';
import { ReactComponent as DragIcon } from 'assets/images/icons/question-design/drag-question.svg';
import { Box } from '@mui/material';
import { IQuestionNewEditForm } from 'types/campaign-design';

interface QuestionDnDProps {
    question?: IQuestionNewEditForm;
    onDragStart?: (event: React.DragEvent, data: IQuestionNewEditForm) => void;
    onDragOver?: (event: React.DragEvent, data: IQuestionNewEditForm) => void;
    onDrop?: (event: React.DragEvent, data: IQuestionNewEditForm) => void;
}
const QuestionDnD: React.FC<QuestionDnDProps> = ({
    question,
    onDragStart,
    onDragOver,
    onDrop,
}) => {
    return (
        <Box
            sx={{ marginTop: '10px' }}
            draggable={true}
            onDragStart={(event) =>
                onDragStart &&
                onDragStart(event, question as IQuestionNewEditForm)
            }
            onDragOver={(event) =>
                onDragOver &&
                onDragOver(event, question as IQuestionNewEditForm)
            }
            onDrop={(event) =>
                onDrop && onDrop(event, question as IQuestionNewEditForm)
            }
        >
            {!question?.setting_logic && <DragIcon />}
        </Box>
    );
};

export default QuestionDnD;
